import {ViewController} from "data/types/structure";
import {inject, injectable} from "inversify";
import {makeAutoObservable, observable} from "mobx";
import {RequestState} from "data/enums";
import {Bindings} from "data/constants/bindings";
import type {ILocalizationStore} from "data/stores/localization/localization.store";
import type {IUserStore} from "data/stores/user/user.store";
import type {ILineup, ITeamStore} from "data/stores/team/team.store";
import type {IRoundsStore, ISession} from "data/stores/rounds/rounds.store";
import {SyntheticEvent} from "react";

export interface IUserTeamSelectorController extends ViewController {
	get i18n(): ILocalizationStore;
	get lineup(): ILineup | null;
	get userTeamSelectedRoundSessions(): ISession[];
	get userTeamsSelectedSessionId(): number;
	get lastCompleteOrPlayingSession(): ISession | undefined;

	onChangeSession: (_event: SyntheticEvent, newValue: string) => void;
}

@injectable()
export class UserTeamSelectorController implements IUserTeamSelectorController {
	@observable _requestState: RequestState = RequestState.IDLE;

	get i18n() {
		return this._i18nStore;
	}

	get lineup() {
		return this._teamStore.userTeam.lineup;
	}

	get userTeamSelectedRoundSessions() {
		return this._roundStore.userTeamSelectedRoundSessions;
	}

	get userTeamsSelectedSessionId() {
		return this._roundStore.userTeamsSelectedSessionId;
	}

	get lastCompleteOrPlayingSession() {
		return this._roundStore.lastCompleteOrPlayingSession;
	}

	constructor(
		@inject(Bindings.UserStore) private _userStore: IUserStore,
		@inject(Bindings.LocalizationStore) private _i18nStore: ILocalizationStore,
		@inject(Bindings.RoundsStore) private _roundStore: IRoundsStore,
		@inject(Bindings.TeamStore) private _teamStore: ITeamStore
	) {
		makeAutoObservable(this);
	}

	onChangeSession = (_event: SyntheticEvent, newValue: string) => {
		this._roundStore.setUserTeamSelectedSessionId(Number(newValue));
	};

	dispose() {
		return;
	}

	init() {
		return;
	}
}
